import { useCallback, useEffect, useRef, useState } from "react";
import { preventivoApi, type VoceElenco } from "@/api/preventivo";

/** Il testo per cercare senza badare a maiuscole e accenti: come `_chiave` del server (NFKD, segni combinanti tolti). */
const chiave = (s: string) => s.normalize("NFKD").replace(/\p{M}/gu, "").toLowerCase();

/** Le voci il cui amministratore contiene `q` (senza maiuscole né accenti), nell'ordine dell'elenco. Con `q` vuota tutte; con
 *  `q` piena i preventivi senza nome non compaiono. Stesse regole di `GET /preventivo/elenco?q=`. La ricerca si fa qui e
 *  non dal server: il nome digitato non deve finire nei log di Apache e di uvicorn (spec § 10). */
export function filtraPerAmministratore(voci: VoceElenco[], q: string): VoceElenco[] {
  const cercato = chiave(q.trim());
  if (!cercato) return voci;
  return voci.filter((v) => v.amministratore !== null && chiave(v.amministratore).includes(cercato));
}

/** L'elenco dei preventivi, tutto, una volta (senza `q`: la ricerca si fa nel browser con `filtraPerAmministratore`). */
export function useElenco() {
  const [voci, setVoci] = useState<VoceElenco[] | null>(null);
  const [errore, setErrore] = useState(false);
  const [tentativo, setTentativo] = useState(0);
  const ultima = useRef(0);
  useEffect(() => {
    const n = ++ultima.current;
    setErrore(false);
    preventivoApi.elenco().then(
      (v) => { if (n === ultima.current) setVoci(v); },
      () => { if (n === ultima.current) setErrore(true); },
    );
    return () => { ultima.current++; };
  }, [tentativo]);
  const riprova = useCallback(() => setTentativo((t) => t + 1), []);
  return { voci, errore, riprova };
}
